<ion-content scroll-y="false">
    <ion-grid>
        <ion-row>
            <ion-col>
                <h4 class="ion-text-center bold">Signature {{signataire}} </h4>
            </ion-col>
        </ion-row>
        <ion-row [ngClass]="{'drawing-active': isDrawing}">
            <ion-col size="12" class="ion-text-center">
                <canvas class="signature-pad-canvas no-touch" #canvas width="300" height="200"></canvas>
            </ion-col>
        </ion-row>
        <ion-row class="ion-justify-content-center">
            <ion-col size="10">
                <ion-button expand="block"
                            color="dark"
                            class="ion-margin-vertical"
                            (click)="annuler()">Annuler
                </ion-button>
                <ion-button expand="block"
                            color="dark"
                            class="ion-margin-vertical"
                            (click)="clearPad()">Effacer
                </ion-button>
                <ion-button expand="block"
                            class="custom ion-margin-vertical"
                            (click)="savePad()">Enregistrer
                </ion-button>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>
